const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  course: state => state.course.course,
  courses: state => state.course.courses,
  students: state => state.course.students,
  homeworks: state => state.course.homeworks,
  ratings: state => state.course.ratings,
  webinars: state => state.course.webinars,
  commissions: state => state.course.commissions,
  commissionsPaginate: state => state.course.commissionsPaginate,
  commissionStatistics: state => state.course.commissionStatistics
}
export default getters
